export default "__VITE_ASSET__1e8525a0__"